import { createContext, useContext } from "react";

const ToastContext = createContext(() => {});

export const ToastProvider = ToastContext.Provider;

/**
 * useNotify() — call from any component to show a toast.
 *
 * Usage:
 *   const notify = useNotify();
 *   notify({ type: "success", title: "Saved", message: "Profile updated." });
 *   notify({ type: "error", title: "Error", message: "Something went wrong." });
 */
export function useNotify() {
  return useContext(ToastContext);
}
